export const IntranetWorker = {
    path: '/intranet_workers',
    name: 'intranet_workers',
    component: () => import('@/views/Intranet/IntranetWorkerPage.vue'),
    children: [
        {
            path: '/intranet_workers/add',
            name: 'intranet_workers.add',
            component: () => import('@/views/Worker/Form/WorkerForm.vue'),
            props: {addAction: true, intranet: true},
        },
        {
            path: '/intranet_workers/edit/:id',
            name: 'intranet_workers.edit',
            component: () => import('@/views/Worker/Form/WorkerForm.vue'),
            props: {updateAction: true, intranet: true},
            children: [
                {
                    path: '/intranet_workers/edit/request/view/:id',
                    name: 'intranet_workers.edit.request.view',
                    component: () => import('@/views/Absence/Vacation/Form/VacationForm.vue'),
                    props: {viewAction: true}
                },
                {
                    path: '/intranet_workers/edit/pay_slip/view/:id',
                    name: 'intranet_workers.edit.pay_slip.view',
                    component: () => import('@/views/PaySlip/Form/PaySlipView.vue'),
                },
            ]
        },
        {
            path: '/intranet_workers/delete/:id',
            name: 'intranet_workers.delete',
            component: () => import('@/views/Worker/Form/WorkerForm.vue'),
            props: {deleteAction: true, intranet: true},
            children: [
                {
                    path: '/intranet_workers/delete/request/view/:id',
                    name: 'intranet_workers.delete.request.view',
                    component: () => import('@/views/Absence/Vacation/Form/VacationForm.vue'),
                    props: {viewAction: true}
                },
                {
                    path: '/intranet_workers/delete/pay_slip/view/:id',
                    name: 'intranet_workers.delete.pay_slip.view',
                    component: () => import('@/views/PaySlip/Form/PaySlipView.vue'),
                },
            ]
        },
        {
            path: '/intranet_workers/view/:id',
            name: 'intranet_workers.view',
            component: () => import('@/views/Worker/Form/WorkerForm.vue'),
            props: {viewAction: true, intranet: true},
            children: [
                {
                    path: '/intranet_workers/view/request/view/:id',
                    name: 'intranet_workers.view.request.view',
                    component: () => import('@/views/Absence/Vacation/Form/VacationForm.vue'),
                    props: {viewAction: true}
                },
                {
                    path: '/intranet_workers/view/pay_slip/view/:id',
                    name: 'intranet_workers.view.pay_slip.view',
                    component: () => import('@/views/PaySlip/Form/PaySlipView.vue'),
                },
            ]
        },
        {
            path: '/intranet_workers/deactivate/:id',
            name: 'intranet_workers.deactivate',
            component: () => import('@/views/Worker/Form/DeactivateForm.vue'),
        },
        {
            path: '/intranet_workers/ats/:id',
            name: 'intranet_workers.ats',
            component: () => import('@/views/Worker/Form/ATSForm.vue'),
        },
        {
            path: '/intranet_workers/set_data_access',
            name: 'intranet_workers.set_data_access',
            component: () => import('@/views/Worker/Form/SetDataAccessForm.vue'),
        },
        {
            path: '/intranet_workers/add_pay_sections',
            name: 'intranet_workers.add_pay_sections',
            component: () => import('@/views/Worker/Form/PaySectionsManage.vue'),
            props: {addAction: true}
        },
        {
            path: '/intranet_workers/delete_pay_sections',
            name: 'intranet_workers.delete_pay_sections',
            component: () => import('@/views/Worker/Form/PaySectionsManage.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/intranet_workers/documents/:id',
            name: 'intranet_workers.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "WORKER"}
        },
        {
            path: '/intranet_workers/template_applications/:id',
            name: 'intranet_workers.template_applications',
            component: () => import('@/views/Edms/TemplateApplication/ModuleTemplateApplicationPage.vue'),
            props: {module: "WORKER"}
        },
    ]
}